import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

class Footer extends React.Component {
    constructor() {
        super();
        this.state = {};
    }

    render() {
        return (
            <div style={{ height: this.state.height }}>
                <div
                    className={`footer-bar footer-bar--${this.props.position} max--${
                        this.props.maxWidthVariation
                    }`}
                    ref={footer => (this.footer = footer)}
                >
                    {this.props.top && this.props.top}
                    <div className="footer-bar__inner">{this.props.children}</div>
                </div>
            </div>
        );
    }
}

Footer.propTypes = {
    visible: PropTypes.bool,
    position: PropTypes.string,
    maxWidthVariation: PropTypes.string,
};

Footer.defaultProps = {
    visible: true,
    position: 'sticky',
    maxWidthVariation: 'desktop',
};

class Element extends React.Component {
    getStyles() {
        let styles = {
            textAlign: this.props.align,
        };

        if (!this.props.verticalPadding) {
            styles.paddingTop = 0;
            styles.paddingBottom = 0;
        }

        return styles;
    }

    getClasses() {
        let classes = ['footer-bar__element'];

        if (this.props.cols) {
            ['small', 'medium', 'normal', 'large'].forEach(size => {
                classes.push(`${size}-${this.props.cols}`);
            });
        }

        return classNames(classes);
    }

    render() {
        return (
            <div style={this.getStyles()} className={this.getClasses()}>
                {this.props.children}
            </div>
        );
    }
}

Element.defaultProps = {
    cols: 12,
    align: 'left',
    verticalPadding: true,
};

export { Footer, Element };
export default Footer;
